import React from 'react';

import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import Leaderboard from './Leaderboard';

export default () => (
  <div className="App">
    <AppHeader />
    <Leaderboard />
    <AppFooter />
  </div>
);
